<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="gridValidator">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <base-input class="mb-3"
                :label="$t('common.name')"
                label-classes="form-control-label required"
                :placeholder="$t('common.name')"
                v-model="value.name"
                name="name"
                rules="required"
                :disabled="published && !duplicating"
                :error="errors.get('name')">
            </base-input>

            <base-input class="mb-3" v-if="!duplicating"
                :label="$t('common.code')"
                label-classes="form-control-label required"
                :placeholder="$t('common.code')"
                v-model="value.code"
                name="code"
                rules="required"
                :error="errors.get('code')">
            </base-input>

            <base-select class="mb-4" v-if="!duplicating"
                :label="$t('common.language')"
                :placeholder="$t('common.language')"
                label-classes="required"
                v-model="value.lang"
                :options="langs"
                :disabled="published"
                @input="errors.clear('lang')"
                :error="errors.get('lang')"
            >
            </base-select>

            <base-select class="mb-4" v-if="!duplicating"
                :label="$t('common.position')"
                :placeholder="$t('common.position')"
                label-classes="required"
                v-model="value.simulation_role"
                :options="simulationRolesLang('en')"
                :notes="simulationRolesLang('fr')"
                :disabled="published"
                @input="errors.clear('simulation_role')"
                :error="errors.get('simulation_role')"
            >
            </base-select>

            <base-select class="mb-4" v-if="!duplicating && !$auth.user.owner_id"
                :label="$t('common.owner')"
                :placeholder="$t('common.owner')"
                v-model="value.owner_id"
                :options="owners"
                @input="errors.clear('owner_id')"
                :error="errors.get('owner_id')"
            >
            </base-select>

            <base-checkbox class="mb-3" v-if="!duplicating"
                v-model="value.shared"
            >
                {{ $t('common.shared') }}
            </base-checkbox>

            <base-select class="mb-4" v-if="!duplicating && value.status != 'active' && value.status != 'archived'"
                :label="$t('common.status')"
                :placeholder="$t('common.status')"
                v-model="value.status"
                :options="statusOptions"
                :sort="false"
            >
            </base-select>

            <div class="category form-category mb-4">
                <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
            </div>

            <div class="text-center" v-if="duplicating">

                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? (duplicating ? $t('common.duplicate') : $t('common.update')) : $t('common.create') }}
                </base-button>
                
                <base-button type="link" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

            <div class="text-center" v-if="!duplicating">

                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                >
                    {{ value.id ? (duplicating ? $t('common.duplicate') : $t('common.update')) : $t('common.create') }}
                </base-button>

                <base-button outline 
                    type="primary"
                    :disabled="errors.any() || invalid"
                    @click="next"
                >
                    {{ $t('common.more') }}
                </base-button>
            </div>

            <div class="text-center mt-3" v-if="!duplicating">
                <base-button type="link" @click="modal.show = false">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {

        props: {
            
            value: {
                type: Object,
                required: true
            },

            errors: {
                type: Object,
                required: true
            },

            modal: {
                type: Object,
                default: null
            },

            duplicating: {
                type: Boolean,
                default: false
            },

            statusOptions: {
                type: Object,
                required: true
            },

            langs: {
                type: Object,
                required: true
            },

            simulationRoles: {
                type: Object,
                required: true
            },

            owners: {
                type: Object,
                required: true
            },
        },

        created() {
            this.errors.setValidator('gridValidator', this)
        },

        watch: {

            duplicating(val) {
                if (this.duplicating) {
                    this.value.name += ' (copy)'
                }
            }
        },

        computed: {

            published() {
                return this.value.status == 'active'
            }
        },

        methods: {
            
            simulationRolesLang(lang) {
                let roles = {}
                for (let id in this.simulationRoles) {
                    roles[id] = this.simulationRoles[id][lang]
                }
                return roles
            },

            submit() {
                if (this.duplicating) {
                    this.$loader.show()
                }
                this.$emit('input', { ...this.value})
            },

            next() {
                this.$emit('next')
                this.submit()
            }
        }
    }
</script>
